import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  FormValidationModule,
  TabsModule,
  SearchBarModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { ButtonGroupControlModule } from '@tablesready/button-group-control';
import { BadgeModule } from '@tablesready/frontend-badge';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { LocationUsersComponent } from './users.component';
import { LocationUsersRoutingModule } from './users.routing.module';
import { EditUserComponent, InviteUserComponent } from './modals';
import { LocationInvitesListComponent, LocationUsersListComponent } from './components';

@NgModule({
  declarations: [
    LocationUsersComponent,
    EditUserComponent,
    InviteUserComponent,
    LocationUsersListComponent,
    LocationInvitesListComponent,
  ],
  imports: [
    NgbModule,
    FrontendIconsModule,
    FormsModule,
    AlertsModule,
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    FormValidationModule,
    LocationUsersRoutingModule,
    ButtonGroupControlModule,
    TabsModule,
    SearchBarModule,
    BadgeModule,
    UtilsModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
    FrontendDropdownModule,
  ],
})
export class LocationUsersModule {}
